import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Module } from "vuex";
import baseModule from "./common";
import { Fetcher as Ajax } from "@/utils/Request";
import { API_REVENUE_CATEGORY } from "@/configs/Apis";
const newModule: Module<any, any> = merge(cloneDeep(baseModule), {
  actions: {
    addRevenueCategory(store: any, payload: any) {
      return Ajax.saveData(API_REVENUE_CATEGORY, payload, "POST");
    },
    updateRevenueCategory(store: any, payload: any) {
      return Ajax.saveData(API_REVENUE_CATEGORY + "/" + payload.id, payload, "PUT");
    },
    deleteRevenueCategory(store: any, categoryFilter: any) {
      return Ajax.saveData(API_REVENUE_CATEGORY, categoryFilter, "DELETE");
    },
  }
});
export default newModule;
